import * as React from "react";

export const Spinner = (props :{}) => (
    <div className="spinner">
        <div className="dot1"></div>
        <div className="dot2"></div>
    </div>
)